interface RouteAccess {
  permissions?: string;
  ownerOnly?: boolean;
}

interface UserAccess {
  permissions?: string[];
  isOwner: boolean;
}

/**
 * Decides whether the current user may access a route.
 *
 * An owner always has access: their JWT carries an empty permissions array, so
 * gating them on `permissions` would lock them out of the very routes they are
 * meant to administer.
 *
 * Otherwise, a route declaring both `ownerOnly` and `permissions` is accessible
 * to a non-owner who holds the required permission — the two flags combine as an
 * "owner OR permission" check, not "owner AND permission". A route declaring only
 * `ownerOnly` (no `permissions`) remains owner-exclusive with no fallback.
 *
 * Used to filter both the rendered routes and the sidebar menu entries.
 */
export const canAccessRoute = (
  route: RouteAccess,
  { permissions, isOwner }: UserAccess,
): boolean => {
  if (isOwner) return true;
  if (route.ownerOnly && !route.permissions) return false;
  if (route.permissions) return Boolean(permissions?.includes(route.permissions));
  return true;
};
